import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import router from './router'


console.log(window.location.host);
// axios 配置
const axiosNew = axios.create({
  baseURL: '//' + window.location.host,
  timeout: 20000,
  withCredentials: true,
  responseType: "json",
  headers: {
    // "Content-Type": "application/json"
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  },
});

function checkNeedTransform(url) {
  // 加密登录 无需转格式
  const no_need_transform_url = [
    '/api/user/login',
    '/api/user/m-login',
    '/api/user/login-by-code',
    '/api/personal-center/update-password',
    '/api/wechat-login/update-password',
    '/api/jp/add-user-relation',
    '/api/jp/update-user-info',
    '/api/jp/modify-password',
    '/api/wechat-login/bind',
    '/api/wechat-login/unbind',
  ]
  let res = no_need_transform_url.findIndex(e => e == url) == -1;
  return res;
}


// http request 拦截器
axiosNew.interceptors.request.use(
  config => {
    // console.log(config);
    if (config.method == "post" && checkNeedTransform(config.url) && config.url.indexOf("/api/file/check-file") < 0) {
      config.transformRequest = function () {
        return Qs.stringify(config.data);
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  },
)

// http response 拦截器
axiosNew.interceptors.response.use(
  response => {
    // if (response.data.errCode == 1) {
    //   Vue.prototype.reportErrorLogFun(Vue.prototype.apiErrorType.api_error_code,response)
    // }
    if (response.data.errCode == -200) {
      Vue.prototype.logout_path(1, router);
    }
    // 请求异常
    // if (response.data.errCode != 0 && response.headers['content-type']!="application/pdf") {
    //     return Promise.reject(response.data.msg);
    // }
    if (response.headers['content-type'] == "application/pdf") {
      return response;
    }
    return response.data
  },
  error => {
    console.log(error);
    //Vue.prototype.reportErrorLogFun(Vue.prototype.apiErrorType.api,error.response)
    return Promise.reject(error.response.data)
  },
)

export default axiosNew